<template>
  <div class="AvatarRowContainer">
    <template v-for="(a,ai) in avatars" :key="`avatar${ai}`">
      <img :src="a" v-if="ai < limit" class="sqr26 brd26 avatar"/>
    </template>
  </div>
</template>

<script>
export default {
  name: "AvatarRow",
  props: {
    limit: {
      type: Number,
      default: ()=>{
        return 4
      }
    },
    avatars: {
      type: Array,
      default: () => {
        return [
          'https://cdn.waityou.online/087a0185-332b-353c-a968-694d00d737a8.jpeg',
          'https://cdn.waityou.online/087a0185-332b-353c-a968-694d00d737a8.jpeg',
          'https://cdn.waityou.online/087a0185-332b-353c-a968-694d00d737a8.jpeg',
          'https://cdn.waityou.online/087a0185-332b-353c-a968-694d00d737a8.jpeg',
          'https://cdn.waityou.online/087a0185-332b-353c-a968-694d00d737a8.jpeg',
          'https://cdn.waityou.online/087a0185-332b-353c-a968-694d00d737a8.jpeg',
          'https://cdn.waityou.online/087a0185-332b-353c-a968-694d00d737a8.jpeg',
        ]
      }
    }
  },
  methods: {
    init() {

    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.AvatarRowContainer {
  display: flex;

  .avatar {
    object-fit: fill;
    border: 2px white solid;
  }

  .avatar:not(:first-child) {
    margin-left: -14px;
  }
}
</style>